import React from 'react';
import { injectIntl } from 'react-intl';

import ListFilterAsyncMultiple from 'components/layout/list/ListFilterAsyncMultiple';
import ListFilterAsyncSingle from 'components/layout/list/ListFilterAsyncSingle';

class ListFilterWhiteLabelProject extends React.Component {
  listItemFormatter = whiteLabelProject => whiteLabelProject.name;

  render() {
    const {
      intl: { messages },
      multi,
    } = this.props;

    const ListFilterComponent = multi ? ListFilterAsyncMultiple : ListFilterAsyncSingle;

    return (
      <ListFilterComponent
        title={messages.white_label}
        listName="myWhiteLabelProject"
        listUrl="/api/whitelabels/my.json"
        listItemFormatter={this.listItemFormatter}
        paramName="whiteLabelProject"
      />
    );
  }
}
ListFilterWhiteLabelProject.defaultProps = {
  multi: true,
};

export default injectIntl(ListFilterWhiteLabelProject);
